export default __webpack_public_path__ + "static/screeny-130-gpz-tens-to-5-51d58425a6e012b302e7ba80ab1915f7.jpg";